import { i18nLike } from "#web/services/i18nLike";
import { Badge, Icon, InlineStack, Tooltip } from "@shopify/polaris";
import { InfoIcon } from "@shopify/polaris-icons";

import { LeakedCode, leakedCodeExists, leakedCodeIsActive } from "./_models/leakedCode";
import { en } from "./LeakedCodesIndexTable/translations";

export const ShopifyStatusBadge = ({ leakedCode }: { leakedCode: LeakedCode }) => {
  const t = i18nLike(en);

  if (!leakedCodeExists(leakedCode)) {
    return (
      <Tooltip content={t("shopifyStatus.doesNotExistTooltip")}>
        <Badge>
          {/* @ts-expect-error type 'Element' should not be allowed here but it does work so we're just going to ignore it */}
          <InlineStack align="center" blockAlign="center">
            {t("shopifyStatus.doesNotExist")} <Icon source={InfoIcon} tone="base" />
          </InlineStack>
        </Badge>
      </Tooltip>
    );
  }

  if (leakedCodeIsActive(leakedCode)) {
    return <Badge tone="success">{t("shopifyStatus.active")}</Badge>;
  }

  return <Badge>{t("shopifyStatus.expired")}</Badge>;
};
